import '../../js/common.js';
import '../../js/idp.js';
import '../../js/reset-input.js';
import { defineCustomElement as defineFroSelect } from '@fronius/design-system-web-components/dist/components/fro-select';
import '../../js/language-switcher.js';
defineFroSelect();
